import React from 'react';

const HomePage = ({ children }) => <div className="page homepage">{children}</div>;

export default HomePage;
